module.exports = "import React from 'react';\nimport FlatButton from 'material-ui/FlatButton';\n\nconst FlatButtonExampleSimple = () => (\n  <div>\n    <FlatButton label=\"Default\" />\n    <FlatButton label=\"Primary\" primary={true} />\n    <FlatButton label=\"Secondary\" secondary={true} />\n    <FlatButton label=\"Disabled\" disabled={true} />\n  </div>\n);\n\nexport default FlatButtonExampleSimple;\n"


/*****************
 ** WEBPACK FOOTER
 ** ./~/raw-loader!./src/app/components/pages/components/FlatButton/ExampleSimple.js
 ** module id = 985
 ** module chunks = 0
 **/